<template>
    <div class="ledger-balanace">
    <div class="card-panel" @click="onClick()">
      <div v-if="ledger">
        <div class="purpose">{{ ledger.purpose }}</div>
        <div :class="'card-panel-icon-wrapper currency-color-'+ledger.currency.toLowerCase()">
          {{ ledger.currency }}
          <!-- <svg-icon
            :icon-class="ledger.currency.toLowerCase()"
            class-name="card-panel-icon"
          /> -->
        </div>
        <div class="card-panel-description" v-if="ledger">
          <div class="card-panel-text">Balance</div>
          <div class="card-panel-num">
            {{ ledger.balanceFormat }}
          </div>
          <div class="card-panel-type">
            {{ `Bank ID ${ledger.bankholderID}` }}
          </div>
          <div class="card-panel-acc" v-if="['GBP'].indexOf(ledger.currency) != -1">Ac No. {{ ledger.accountNumber }} Sortcode {{ ledger.sortcode }}</div>
          <div class="card-panel-acc" v-if="['GBP', 'EUR'].indexOf(ledger.currency) != -1">IBAN {{ ledger.iban }}</div>
          <div class="card-panel-acc" v-if="['GBP', 'EUR'].indexOf(ledger.currency) != -1">BIC {{ ledger.bic }}</div>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      ledger : {
        type: Object,
        default: {}
      }
    },
    methods:{
      onClick(){
        this.$emit("onClick")
      }
    }
  }
</script>

<style lang="scss" scoped>
.ledger-balanace{
    .card-panel {
    height: 110px;
    
    font-size: 10px;
    position: relative;
    overflow: hidden;
    color: #8c8c8c;
    background-color: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
    border: 1px solid #fff;

    &:hover {
      cursor: pointer;
      background-color: #e8f3ff;
      -webkit-box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
      box-shadow: 4px 4px 40px #409eff29;
      border-color: #deeeff;
      -webkit-transition: background-color .2s ease-out;
      transition: background-color .2s ease-out;
    }

    .icon-people {
      color: #40c9c6;
    }

    .purpose{
      padding: 10px 0;
      font-size: 14px;
      position: absolute;
      left: 10px;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 45px 0 0 10px;
      padding: 0;
      transition: all 0.38s ease-out;
      border-radius: 6px;
      font-size: 1.5rem;
      font-weight: bold;
      color: #36a3f7;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 10px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 10px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        margin-bottom: 8px;
        text-align: right;
      }

      .card-panel-num {
        font-size: 16px;
        text-align: right;
        margin-bottom: 7px;
        color: #666;
      }
      .card-panel-acc {
        text-align: right;
        margin-bottom: 3px;
      }
      .card-panel-type {
        text-align: right;
      }
    }
  }
  

}
</style>